import { useState } from 'react';
import api from '../../lib/api';
import { Button } from '../ui/button';
import { PhoneCall, Check, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export const CALLBACK_SLA_COPY = 'Our team will call you within 24 hours (except Sunday).';

/** V38/V44 — the ONLY way a learner reaches the team from inside the app: a callback request filed to the
 *  OPS desk. Never a WhatsApp / email link. Optional `plan` scopes membership enquiries (V31). */
export const TalkToTeamButton = ({ plan, label = 'Request a callback', category = 'membership', message, context,
                                   testId, className = '', size = 'sm', variant = 'outline' }) => {
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const send = async () => {
    setBusy(true);
    try {
      const res = await api.post('/api/soulai/speak-to-team', { plan, category, channel: 'speak_to_team', message, context });
      setSent(true);
      toast.success(res.data?.message || `Request received — ${CALLBACK_SLA_COPY}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not send your request — please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button size={size} variant={variant} onClick={send} disabled={busy || sent}
      data-testid={testId || 'request-callback-btn'} className={`gap-1.5 rounded-full ${size === 'sm' ? 'h-8 text-xs mt-2' : ''} ${className}`}>
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" />
        : sent ? <Check className="h-3.5 w-3.5" /> : <PhoneCall className="h-3.5 w-3.5" />}
      {sent ? 'Callback requested — within 24 hrs (except Sunday)' : label}
    </Button>
  );
};

export default TalkToTeamButton;
